export default __webpack_public_path__ + "static/media/carlos_rebollon.439dad7a.jpg";